module.exports = __webpack_public_path__ + "img/logo1.af9b9199.png";